/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bitcoin_chain_about = () => `Bitcoin stands as a leading cryptocurrency and payment network, utilizing peer-to-peer technology to operate without central authorities. It embraces global participation as an open-source platform. A notable advancement in Bitcoin is the introduction of ordinals and inscriptions. Launched in January 2023, the Bitcoin ordinals protocol enables the embedding of digital content like art, text, or video directly onto the Bitcoin blockchain. This innovation allows for the creation of exclusive digital collectibles, giving each satoshi a unique identity and purpose, broadening Bitcoin's utility beyond its role as a store of value.`
